// import React, { useEffect, useState } from "react";
// import AppNavbar from "../../Navbar/AppNavbar";
// import Footer from "../../Navbar/Footer";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
// import { SearchBtn, UploadBtn } from "../../Buttons/Buttons";
// import UploadCSVModal from "./UploadCSVModal";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllUploads, loadDownlodFiles } from "../../redux/action";

// const UploadCSV = () => {
//     let dispatch = useDispatch();
//     const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
//     const role=signInDetails[0]?.role;
//     const sbnId=signInDetails[0]?.sbn_id;
//     const usrId=signInDetails[0]?.id;

//     const [pageSize,setPageSize]=useState(1);
//     const  [limit]=useState(100);
//     const [loading, setLoading] = useState(false);
//     const [uploads, setUploads] = useState([]);
//     const {get_uplaoads} = useSelector(state => state.data);

//     const [openModal, setOpenModal] = useState(false);

//     const handleUploadClick = () => {
//         setOpenModal(true);  
//     };

//     const handleCloseModal = () => {
//         setOpenModal(false);  // Close the modal
//     };

//     useEffect(() => {
//     setLoading(true);
//     dispatch(getAllUploads(limit, pageSize, role, sbnId, usrId));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [pageSize]);

//    useEffect(() => {
//     if (get_uplaoads?.length > 0) {
//       setUploads((prev) => {
//         // Prevent duplicates when scrolling back up or re-fetching same page
//         const newData = get_uplaoads.filter(
//           (item) => !prev.some((p) => p.upload_id === item.upload_id)
//         );
//         return [...prev, ...newData];
//       });
//       setLoading(false);
//     }
//   }, [get_uplaoads]);

//     useEffect(() => {
//     const handleScroll = () => {
//       const bottom =
//         window.innerHeight + window.scrollY >=
//         document.documentElement.scrollHeight - 100;

//       if (bottom && !loading) {
//         setLoading(true);
//         setPageSize((prev) => prev + 1);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [loading]);


//     // #region download file function
//     const downloadFile = (upload_id, file_name) => {
//         dispatch(loadDownlodFiles(upload_id, file_name))
//     }
//     // #endregion

//     return (
//         <div className="page-layout">
//             <AppNavbar />
//             <div className="page-content">
//                 <div className="saved-search-container">
//                     <div className="saved-search-header-container">
//                         <div className="saved-search-header-div">
//                             <p>Data</p>
//                             <div className="saved-search-img-div">
//                                 <h5>Uploads</h5>
//                                 <i className="fa-solid fa-arrow-up-from-bracket"></i>
//                             </div>
//                         </div>
//                         <div className="d-flex gap-2">
//                             <UploadBtn btnName='Upload' onClickEffect={handleUploadClick} />
//                             <SearchBtn btnName='Sample *CSV' />
//                         </div>
//                     </div>

//                     <TableContainer component={Paper} className="flagged-contact-table">
//                         <Table aria-label="upload table">
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell style={{ minWidth: "80px" }}>Sl.no</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>Upload Number</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>User Name</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>Fresh Count</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>Duplicate Count</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>Invalid Count</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>Invalid Email Data</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>Invalid Location</TableCell>
//                                     <TableCell style={{ minWidth: "180px" }}>Miss Match Data</TableCell>
//                                     <TableCell style={{ minWidth: "250px" }}>Uploaded Date</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {get_uplaoads.length !== 0 && get_uplaoads.map((row, index) => (
//                                     <TableRow key={row.id}>
//                                         <TableCell>{index + 1}</TableCell>
//                                         <TableCell>{row.upload_id}</TableCell>
//                                         <TableCell>{row.username}</TableCell>
//                                         <TableCell>{row.fresh}</TableCell>
//                                         <TableCell>{row.repeated}</TableCell>
//                                         <TableCell>{row.invalid_records_count > 0 ? <span>{row.invalid_records_count} <span className="file-download"
//                                             onClick={(e) => downloadFile(row.upload_id, row.invalid_record_within_csv)}>Download</span></span> : 0}</TableCell>
//                                         <TableCell>{row.invalid > 0 ? <span>{row.invalid} <span className="file-download"
//                                             onClick={(e) => downloadFile(row.upload_id, row.invalid_file)}>Download</span></span> : 0}</TableCell>
//                                         <TableCell>{row.invalid_locations_count > 0 ? <span>{row.invalid_locations_count} <span className="file-download"
//                                             onClick={(e) => downloadFile(row.upload_id, row.invalid_locations)}>Download</span></span> : 0}</TableCell>
//                                         <TableCell>{row.miss_match_data_count > 0 ? <span>{row.miss_match_data_count} <span className="file-download"
//                                             onClick={(e) => downloadFile(row.upload_id, row.miss_match_data_file)}>Download</span></span> : 0}</TableCell>
//                                         <TableCell>{row.uploaded_date}</TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </div>
//             </div>
//             {/* Use the modal component here */}
//             {openModal &&
//                 <UploadCSVModal
//                     show={openModal}
//                     handleClose={handleCloseModal}
//                 />
//             }
//             <Footer />
//         </div>
//     );
// };

// export default UploadCSV;

import React, { useEffect, useState, useRef, useCallback } from "react";
// import AppNavbar from "../../Navbar/AppNavbar";
import AppLayout from "../../Navbar/AppLayout";
import Footer from "../../Navbar/Footer";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";
import { SearchBtn, UploadBtn } from "../../Buttons/Buttons";
import UploadCSVModal from "./UploadCSVModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllUploads, loadDownlodFiles } from "../../redux/action";
import { handleScroll } from "../../CommonFile/OnScrollFunction";

const UploadCSV = () => {
    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const role = signInDetails[0]?.role;
    const sbnId = signInDetails[0]?.sbn_id;
    const usrId = signInDetails[0]?.id;

    const [pageSize, setPageSize] = useState(1);
    const [limit, setLimit] = useState(25); // number of records per page
    const [isLoading, setIsLoading] = useState(false);
    // const [hasMore, setHasMore] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    // const [uploads, setUploads] = useState([]);
    const { get_uplaoads } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const containerRef = useRef(null);
    const [loadingMore, setLoadingMore] = useState(true);
    // const lastScrollTopRef = useRef(0);

    // const observer = useRef();

    // const lastRowRef = useCallback(
    //     (node) => {
    //         if (isLoading) return;
    //         if (observer.current) observer.current.disconnect();
    //         observer.current = new IntersectionObserver((entries) => {
    //             if (entries[0].isIntersecting && hasMore) {
    //                 setPageSize((prevPage) => prevPage + 1);
    //             }
    //         });
    //         if (node) observer.current.observe(node);
    //     },
    //     [isLoading, hasMore]
    // );

    const handleUploadClick = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);


    // const fetchData = () => {
    //     dispatch(getAllUploads(limit, pageSize, role, sbnId, usrId))
    // }

    const fetchData =  (pageNo) => {
        setIsLoading(true);
        dispatch(getAllUploads(limit, pageNo, role, sbnId, usrId,get_uplaoads,setLoadingMore));
    };

    useEffect(() => {
        console.log(loadingMore, "loadingMore")
        if(loadingMore){

            fetchData(pageSize);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingMore]);

    


    const downloadFile = (upload_id, file_name) => {
        dispatch(loadDownlodFiles(upload_id, file_name));
    };

    return (
        <div className="page-layout">
            {/* <AppNavbar /> */}
            <AppLayout>
            <div className="page-content">
                <div className="saved-search-container">
                    <div className="saved-search-header-container">
                        <div className="saved-search-header-div">
                            <p>Data</p>
                            <div className="saved-search-img-div">
                                <h5>Uploads</h5>
                                <i className="fa-solid fa-arrow-up-from-bracket"></i>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            <UploadBtn btnName="Upload" onClickEffect={handleUploadClick} />
                            <SearchBtn btnName="Sample *CSV" />
                        </div>
                    </div>

                    <TableContainer component={Paper} className="flagged-contact-table"
                        onScroll={(e) =>
                            handleScroll(
                            e,
                            get_uplaoads,
                            totalDataCount,
                            setLoadingMore,
                            pageSize,
                            setPageSize,
                            loadingMore
                            )
                        }
                        ref={(el) => (containerRef.current = el)}>
                        <Table aria-label="upload table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ minWidth: "80px" }}>Sl.no</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Upload Number</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>User Name</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Fresh Count</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Duplicate Count</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Invalid Count</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Invalid Email Data</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Invalid Location</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Miss Match Data</TableCell>
                                    <TableCell style={{ minWidth: "250px" }}>Uploaded Date</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {get_uplaoads.length > 0 &&
                                    get_uplaoads.map((row, index) => {
                                        return (
                                            <TableRow
                                                key={row.id}
                                            >
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{row.upload_id}</TableCell>
                                                <TableCell>{row.username}</TableCell>
                                                <TableCell>{row.fresh}</TableCell>
                                                <TableCell>{row.repeated}</TableCell>
                                                <TableCell>
                                                    {row.invalid_records_count > 0 ? (
                                                        <span>
                                                            {row.invalid_records_count}{" "}
                                                            <span
                                                                className="file-download"
                                                                onClick={() =>
                                                                    downloadFile(row.upload_id, row.invalid_record_within_csv)
                                                                }
                                                            >
                                                                Download
                                                            </span>
                                                        </span>
                                                    ) : (
                                                        0
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {row.invalid > 0 ? (
                                                        <span>
                                                            {row.invalid}{" "}
                                                            <span
                                                                className="file-download"
                                                                onClick={() =>
                                                                    downloadFile(row.upload_id, row.invalid_file)
                                                                }
                                                            >
                                                                Download
                                                            </span>
                                                        </span>
                                                    ) : (
                                                        0
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {row.invalid_locations_count > 0 ? (
                                                        <span>
                                                            {row.invalid_locations_count}{" "}
                                                            <span
                                                                className="file-download"
                                                                onClick={() =>
                                                                    downloadFile(row.upload_id, row.invalid_locations)
                                                                }
                                                            >
                                                                Download
                                                            </span>
                                                        </span>
                                                    ) : (
                                                        0
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {row.miss_match_data_count > 0 ? (
                                                        <span>
                                                            {row.miss_match_data_count}{" "}
                                                            <span
                                                                className="file-download"
                                                                onClick={() =>
                                                                    downloadFile(row.upload_id, row.miss_match_data_file)
                                                                }
                                                            >
                                                                Download
                                                            </span>
                                                        </span>
                                                    ) : (
                                                        0
                                                    )}
                                                </TableCell>
                                                <TableCell>{row.uploaded_date}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {isLoading && (
                        <p className="text-center mt-3 mb-3">Loading more uploads...</p>
                    )}
                </div>
            </div>
            

            {openModal && (
                <UploadCSVModal show={openModal} handleClose={handleCloseModal} />
            )}
            </AppLayout>
            <Footer />
        </div>
    );
};

export default UploadCSV;

